export default ({spineerStyle,...props}) => {

  return <div {...props}>
    <div className="d-flex justify-content-center" >
      <div className="spinner-border  mx-auto" role="status" style={{color:'#0d77fc',...spineerStyle}}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>;
}